import type { Option } from "@hoylu/client-common";
import React from "react";
import { ProjectSelectorLabel } from "./ProjectSelectorLabel";
import type { ProjectOption } from "./types";

export const ProjectValueRenderer = (value: Option<ProjectOption>[]) => {
  const selectedOption = value[0];
  if (!selectedOption) return null;
  const project = selectedOption.value;

  return (
    <ProjectSelectorLabel
      color={project.color}
      endDate={project.endDate}
      hasAdmin={project.hasAdmin}
      icon={project.icon}
      name={project.name}
      status={project.status}
    />
  );
};
